module.exports = __webpack_public_path__ + "static/media/sherritt-header-0001.0855da82.jpg";